<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";
import TaxReturnTable from "@/components/accountants/tax_return/table/TaxReturnTable.vue";
import TaxReturnTableHeader from "@/components/accountants/tax_return/table/TaxReturnTableHeader.vue";

export default {
  name: "TaxReturnWarrantySection",
  components: {TaxReturnTableHeader, TaxReturnTable, TaxReturnTableRow},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <TaxReturnTable>
    <template v-slot:header>
      <TaxReturnTableHeader/>
    </template>

    <template v-slot:body>
      <TaxReturnTableRow :description="$gettext('Garantievoorziening')"
                         :calculated-value="data.calculated.balance_passive_warranty_provision"
                         v-model="data.edit.balance_passive_warranty_provision"/>

      <TaxReturnTableRow :description="$gettext('Overige voorzieningen')"
                         :calculated-value="data.calculated.balance_passive_warranty_other"
                         v-model="data.edit.balance_passive_warranty_other"/>
    </template>
  </TaxReturnTable>
</template>

<style scoped lang="scss">
table {
  width: 100%;
}
</style>